/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ErrorModel } from '../models/error-model';
import { redirectToMyAsiWithCustomerNumber } from '../fn/public/redirect-to-my-asi-with-customer-number';
import { RedirectToMyAsiWithCustomerNumber$Params } from '../fn/public/redirect-to-my-asi-with-customer-number';
import { redirectToMySvgWithCustomerNumber } from '../fn/public/redirect-to-my-svg-with-customer-number';
import { RedirectToMySvgWithCustomerNumber$Params } from '../fn/public/redirect-to-my-svg-with-customer-number';

@Injectable({ providedIn: 'root' })
export class PublicService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `redirectToMyAsiWithCustomerNumber()` */
  static readonly RedirectToMyAsiWithCustomerNumberPath = '/public/redirect/myasi/{customerNumber}';

  /**
   * Redirect to customer context in myASI.
   *
   * This api call will not return a resource, but redirects into myasi client app. It creates a deeplink for the given customer. After browser redirects to myasi, the user must login, to authenticate and authorize.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `redirectToMyAsiWithCustomerNumber()` instead.
   *
   * This method doesn't expect any request body.
   */
  redirectToMyAsiWithCustomerNumber$Response(params: RedirectToMyAsiWithCustomerNumber$Params, context?: HttpContext): Observable<StrictHttpResponse<ErrorModel>> {
    return redirectToMyAsiWithCustomerNumber(this.http, this.rootUrl, params, context);
  }

  /**
   * Redirect to customer context in myASI.
   *
   * This api call will not return a resource, but redirects into myasi client app. It creates a deeplink for the given customer. After browser redirects to myasi, the user must login, to authenticate and authorize.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `redirectToMyAsiWithCustomerNumber$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  redirectToMyAsiWithCustomerNumber(params: RedirectToMyAsiWithCustomerNumber$Params, context?: HttpContext): Observable<ErrorModel> {
    return this.redirectToMyAsiWithCustomerNumber$Response(params, context).pipe(
      map((r: StrictHttpResponse<ErrorModel>): ErrorModel => r.body)
    );
  }

  /** Path part for operation `redirectToMySvgWithCustomerNumber()` */
  static readonly RedirectToMySvgWithCustomerNumberPath = '/public/redirect/mysvg/{customerNumber}';

  /**
   * Redirect to customer context in mySVG.
   *
   * This api call will not return a resource, but redirects into mysvg client app. It creates a deeplink for the given customer. After browser redirects to mysvg, the user must login, to authenticate and authorize.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `redirectToMySvgWithCustomerNumber()` instead.
   *
   * This method doesn't expect any request body.
   */
  redirectToMySvgWithCustomerNumber$Response(params: RedirectToMySvgWithCustomerNumber$Params, context?: HttpContext): Observable<StrictHttpResponse<ErrorModel>> {
    return redirectToMySvgWithCustomerNumber(this.http, this.rootUrl, params, context);
  }

  /**
   * Redirect to customer context in mySVG.
   *
   * This api call will not return a resource, but redirects into mysvg client app. It creates a deeplink for the given customer. After browser redirects to mysvg, the user must login, to authenticate and authorize.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `redirectToMySvgWithCustomerNumber$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  redirectToMySvgWithCustomerNumber(params: RedirectToMySvgWithCustomerNumber$Params, context?: HttpContext): Observable<ErrorModel> {
    return this.redirectToMySvgWithCustomerNumber$Response(params, context).pipe(
      map((r: StrictHttpResponse<ErrorModel>): ErrorModel => r.body)
    );
  }

}
